import { ForwardedRef, forwardRef, ReactNode } from "react";
import { tv, VariantProps } from "tailwind-variants";

const styles = tv({
  slots: {
    base: "font-bold",
  },
  variants: {
    variant: {
      primary: "text-primary",
      secondary: "text-secondary",
    },
  },
});

interface IProps {
  variant?: VariantProps<typeof styles>["variant"];
  children: ReactNode;
}

const Bold = forwardRef(
  (
    { variant = "secondary", children }: IProps,
    ref: ForwardedRef<HTMLSpanElement | null>,
  ) => {
    const { base } = styles({ variant });

    return (
      <span ref={ref} className={base()}>
        {children}
      </span>
    );
  },
);

export default Bold;
